'use client';

import { createContext, useCallback, useContext, useState } from 'react';

export const FiltersDialogContext = createContext<{
  isMobileFiltersDialogOpen: boolean;
  handleMobileFiltersDialogChange: (open: boolean) => void;
} | null>(null);

export function FiltersDialogContextProvider(props: React.PropsWithChildren<unknown>) {
  const { children } = props;

  const [isMobileFiltersDialogOpen, setIsMobileFiltersDialogOpen] = useState(false);

  const handleMobileFiltersDialogChange = useCallback((open: boolean) => {
    setIsMobileFiltersDialogOpen(open);
  }, []);

  return (
    <FiltersDialogContext.Provider
      value={{ isMobileFiltersDialogOpen, handleMobileFiltersDialogChange }}
    >
      {children}
    </FiltersDialogContext.Provider>
  );
}

export function useFiltersDialogContext(): {
  isMobileFiltersDialogOpen: boolean;
  handleMobileFiltersDialogChange: (open: boolean) => void;
} {
  const context = useContext(FiltersDialogContext);
  if (!context) throw new Error('Missing FiltersDialogContextProvider in the tree');
  return context;
}
